<app-common-page-breadcrumbs [pageTitle]="title" [navigationData]="navigationData"></app-common-page-breadcrumbs>

  <div class="container mt-4 d-flex">
    <div class="w-75">
      <div class="mt-5 p-3 bg-white border rounded-8">
        <a [routerLink]="['groupcompanies']">
          <h4 class="strong"> <i class="fa fa-sitemap mr-2"></i>{{ 'home.groupCompanies' | cxTranslate}}</h4>
          <p class='f-14'>Group Companies represent departments, stores, regions, or any other logical grouping that makes sense to
            you. Approvers are assigned to units and individual users. Units also store the shipping addresses buyers
            can use when making purchases.
          </p>
        </a>
      </div>
      <div class="mt-5 p-3 bg-white border rounded-8">
        <a [routerLink]="['contacts']">
          <h4 class="strong"> <i class="fa fa-user mr-2"></i>{{ 'home.contacts' | cxTranslate}}</h4>
          <p class='f-14'>Users are the buyers, approvers, managers, and administrators of your organization. Each user is assigned a
            role for making or approving purchases.
          </p>
        </a>
      </div>
      <div class="mt-5 mb-5 p-3 bg-white border rounded-8">
        <a [routerLink]="['addressBook']">
          <h4 class="strong"> <i class="fa fa-user mr-2"></i>{{ 'home.addressBook' |
            cxTranslate}}</h4>
          <p class='f-14'>My shipping and billing addresses
          </p>
        </a>
      </div>
    </div>
  </div>
